// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: Xb5xo2JxQe

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Title from "../../Title"; // plasmic-import: LHZTBNzdnP/component
import CircleButton from "../../CircleButton"; // plasmic-import: CMg-M2mVji/component
import HubCreation from "../../HubCreation"; // plasmic-import: z5fIHof2db/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicHubSelection.module.css"; // plasmic-import: Xb5xo2JxQe/css

createPlasmicElementProxy;

export type PlasmicHubSelection__VariantMembers = {
  justAListOfHubs: "justAListOfHubs";
  context: "mainModal" | "welcomeView";
  showHubCreationPanel: "showHubCreationPanel";
  blurContent: "blurContent";
  scrollableList: "scrollableList";
};
export type PlasmicHubSelection__VariantsArgs = {
  justAListOfHubs?: SingleBooleanChoiceArg<"justAListOfHubs">;
  context?: SingleChoiceArg<"mainModal" | "welcomeView">;
  showHubCreationPanel?: SingleBooleanChoiceArg<"showHubCreationPanel">;
  blurContent?: SingleBooleanChoiceArg<"blurContent">;
  scrollableList?: SingleBooleanChoiceArg<"scrollableList">;
};
type VariantPropType = keyof PlasmicHubSelection__VariantsArgs;
export const PlasmicHubSelection__VariantProps = new Array<VariantPropType>(
  "justAListOfHubs",
  "context",
  "showHubCreationPanel",
  "blurContent",
  "scrollableList"
);

export type PlasmicHubSelection__ArgsType = {
  currentHub?: React.ReactNode;
  hubList?: React.ReactNode;
  hubTitle?: React.ReactNode;
  headline?: React.ReactNode;
};
type ArgPropType = keyof PlasmicHubSelection__ArgsType;
export const PlasmicHubSelection__ArgProps = new Array<ArgPropType>(
  "currentHub",
  "hubList",
  "hubTitle",
  "headline"
);

export type PlasmicHubSelection__OverridesType = {
  root?: p.Flex<"div">;
  currentHubContainer?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  blueDivider?: p.Flex<"div">;
  hubListContainer?: p.Flex<"div">;
  text?: p.Flex<"div">;
  welcome?: p.Flex<typeof Title>;
  createHubButton?: p.Flex<typeof CircleButton>;
  hubCreation?: p.Flex<typeof HubCreation>;
};

export interface DefaultHubSelectionProps {
  currentHub?: React.ReactNode;
  hubList?: React.ReactNode;
  hubTitle?: React.ReactNode;
  headline?: React.ReactNode;
  justAListOfHubs?: SingleBooleanChoiceArg<"justAListOfHubs">;
  context?: SingleChoiceArg<"mainModal" | "welcomeView">;
  showHubCreationPanel?: SingleBooleanChoiceArg<"showHubCreationPanel">;
  blurContent?: SingleBooleanChoiceArg<"blurContent">;
  scrollableList?: SingleBooleanChoiceArg<"scrollableList">;
  className?: string;
}

const $$ = {};

function PlasmicHubSelection__RenderFunc(props: {
  variants: PlasmicHubSelection__VariantsArgs;
  args: PlasmicHubSelection__ArgsType;
  overrides: PlasmicHubSelection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "justAListOfHubs",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.justAListOfHubs
      },
      {
        path: "context",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.context
      },
      {
        path: "showHubCreationPanel",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.showHubCreationPanel
      },
      {
        path: "blurContent",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.blurContent
      },
      {
        path: "scrollableList",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.scrollableList
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootcontext_welcomeView]: hasVariant(
            $state,
            "context",
            "welcomeView"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"currentHubContainer"}
        data-plasmic-override={overrides.currentHubContainer}
        className={classNames(projectcss.all, sty.currentHubContainer, {
          [sty.currentHubContainerblurContent_showHubCreationPanel]:
            hasVariant($state, "blurContent", "blurContent") &&
            hasVariant($state, "showHubCreationPanel", "showHubCreationPanel"),
          [sty.currentHubContainercontext_welcomeView]: hasVariant(
            $state,
            "context",
            "welcomeView"
          ),
          [sty.currentHubContainerjustAListOfHubs]: hasVariant(
            $state,
            "justAListOfHubs",
            "justAListOfHubs"
          )
        })}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox, {
            [sty.freeBoxcontext_welcomeView]: hasVariant(
              $state,
              "context",
              "welcomeView"
            ),
            [sty.freeBoxjustAListOfHubs]: hasVariant(
              $state,
              "justAListOfHubs",
              "justAListOfHubs"
            )
          })}
        >
          {(hasVariant($state, "context", "welcomeView") ? false : true)
            ? p.renderPlasmicSlot({
                defaultContents: "Interest based Hub",
                value: args.currentHub,
                className: classNames(sty.slotTargetCurrentHub, {
                  [sty.slotTargetCurrentHubblurContent_showHubCreationPanel]:
                    hasVariant($state, "blurContent", "blurContent") &&
                    hasVariant(
                      $state,
                      "showHubCreationPanel",
                      "showHubCreationPanel"
                    ),
                  [sty.slotTargetCurrentHubcontext_welcomeView]: hasVariant(
                    $state,
                    "context",
                    "welcomeView"
                  ),
                  [sty.slotTargetCurrentHubjustAListOfHubs]: hasVariant(
                    $state,
                    "justAListOfHubs",
                    "justAListOfHubs"
                  ),
                  [sty.slotTargetCurrentHubscrollableList]: hasVariant(
                    $state,
                    "scrollableList",
                    "scrollableList"
                  )
                })
              })
            : null}
          {(hasVariant($state, "context", "welcomeView") ? true : false)
            ? p.renderPlasmicSlot({
                defaultContents: "Your Hubs",
                value: args.headline,
                className: classNames(sty.slotTargetHeadline, {
                  [sty.slotTargetHeadlinecontext_welcomeView]: hasVariant(
                    $state,
                    "context",
                    "welcomeView"
                  ),
                  [sty.slotTargetHeadlinejustAListOfHubs]: hasVariant(
                    $state,
                    "justAListOfHubs",
                    "justAListOfHubs"
                  )
                })
              })
            : null}
        </div>
        {(hasVariant($state, "context", "welcomeView") ? false : true) ? (
          <div
            data-plasmic-name={"blueDivider"}
            data-plasmic-override={overrides.blueDivider}
            className={classNames(projectcss.all, sty.blueDivider, {
              [sty.blueDividercontext_welcomeView]: hasVariant(
                $state,
                "context",
                "welcomeView"
              )
            })}
          />
        ) : null}
      </div>
      <p.Stack
        as={"div"}
        data-plasmic-name={"hubListContainer"}
        data-plasmic-override={overrides.hubListContainer}
        hasGap={true}
        className={classNames(projectcss.all, sty.hubListContainer, {
          [sty.hubListContainerblurContent_showHubCreationPanel]:
            hasVariant($state, "blurContent", "blurContent") &&
            hasVariant($state, "showHubCreationPanel", "showHubCreationPanel"),
          [sty.hubListContainerjustAListOfHubs]: hasVariant(
            $state,
            "justAListOfHubs",
            "justAListOfHubs"
          ),
          [sty.hubListContainerscrollableList]: hasVariant(
            $state,
            "scrollableList",
            "scrollableList"
          )
        })}
      >
        {p.renderPlasmicSlot({
          defaultContents: null,
          value: args.hubList
        })}
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text,
            {
              [sty.textcontext_welcomeView]: hasVariant(
                $state,
                "context",
                "welcomeView"
              ),
              [sty.textjustAListOfHubs]: hasVariant(
                $state,
                "justAListOfHubs",
                "justAListOfHubs"
              )
            }
          )}
        >
          {"-"}
        </div>
        {(
          hasVariant($state, "context", "welcomeView")
            ? false
            : hasVariant($state, "justAListOfHubs", "justAListOfHubs")
            ? true
            : true
        ) ? (
          <Title
            data-plasmic-name={"welcome"}
            data-plasmic-override={overrides.welcome}
            className={classNames("__wab_instance", sty.welcome, {
              [sty.welcomecontext_welcomeView]: hasVariant(
                $state,
                "context",
                "welcomeView"
              ),
              [sty.welcomejustAListOfHubs]: hasVariant(
                $state,
                "justAListOfHubs",
                "justAListOfHubs"
              )
            })}
            hubTitle={p.renderPlasmicSlot({
              defaultContents: (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cbPa9
                  )}
                >
                  {"Welcome"}
                </div>
              ),
              value: args.hubTitle
            })}
          />
        ) : null}
      </p.Stack>
      <CircleButton
        data-plasmic-name={"createHubButton"}
        data-plasmic-override={overrides.createHubButton}
        className={classNames("__wab_instance", sty.createHubButton, {
          [sty.createHubButtoncontext_mainModal]: hasVariant(
            $state,
            "context",
            "mainModal"
          ),
          [sty.createHubButtoncontext_welcomeView]: hasVariant(
            $state,
            "context",
            "welcomeView"
          ),
          [sty.createHubButtonjustAListOfHubs]: hasVariant(
            $state,
            "justAListOfHubs",
            "justAListOfHubs"
          ),
          [sty.createHubButtonshowHubCreationPanel]: hasVariant(
            $state,
            "showHubCreationPanel",
            "showHubCreationPanel"
          )
        })}
        color={
          hasVariant($state, "context", "welcomeView") ? "logoBlue" : undefined
        }
        scale={"medium"}
      />

      <HubCreation
        data-plasmic-name={"hubCreation"}
        data-plasmic-override={overrides.hubCreation}
        className={classNames("__wab_instance", sty.hubCreation, {
          [sty.hubCreationblurContent_showHubCreationPanel]:
            hasVariant($state, "blurContent", "blurContent") &&
            hasVariant($state, "showHubCreationPanel", "showHubCreationPanel"),
          [sty.hubCreationshowHubCreationPanel]: hasVariant(
            $state,
            "showHubCreationPanel",
            "showHubCreationPanel"
          )
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "currentHubContainer",
    "freeBox",
    "blueDivider",
    "hubListContainer",
    "text",
    "welcome",
    "createHubButton",
    "hubCreation"
  ],
  currentHubContainer: ["currentHubContainer", "freeBox", "blueDivider"],
  freeBox: ["freeBox"],
  blueDivider: ["blueDivider"],
  hubListContainer: ["hubListContainer", "text", "welcome"],
  text: ["text"],
  welcome: ["welcome"],
  createHubButton: ["createHubButton"],
  hubCreation: ["hubCreation"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  currentHubContainer: "div";
  freeBox: "div";
  blueDivider: "div";
  hubListContainer: "div";
  text: "div";
  welcome: typeof Title;
  createHubButton: typeof CircleButton;
  hubCreation: typeof HubCreation;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHubSelection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHubSelection__VariantsArgs;
    args?: PlasmicHubSelection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHubSelection__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHubSelection__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHubSelection__ArgProps,
          internalVariantPropNames: PlasmicHubSelection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHubSelection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHubSelection";
  } else {
    func.displayName = `PlasmicHubSelection.${nodeName}`;
  }
  return func;
}

export const PlasmicHubSelection = Object.assign(
  // Top-level PlasmicHubSelection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    currentHubContainer: makeNodeComponent("currentHubContainer"),
    freeBox: makeNodeComponent("freeBox"),
    blueDivider: makeNodeComponent("blueDivider"),
    hubListContainer: makeNodeComponent("hubListContainer"),
    text: makeNodeComponent("text"),
    welcome: makeNodeComponent("welcome"),
    createHubButton: makeNodeComponent("createHubButton"),
    hubCreation: makeNodeComponent("hubCreation"),

    // Metadata about props expected for PlasmicHubSelection
    internalVariantProps: PlasmicHubSelection__VariantProps,
    internalArgProps: PlasmicHubSelection__ArgProps
  }
);

export default PlasmicHubSelection;
/* prettier-ignore-end */
